<script lang="ts">
  import './app.scss';
  import Base from '@components/forms/Base.svelte';
  import Newsletter from '@components/forms/Newsletter.svelte';
  import Referral from '@components/forms/Referral.svelte';
  import Enquiry from '@components/forms/Enquiry.svelte';

  // Props with defaults
  export let type: 'Enquiry' | 'Referral' | 'Newsletter' = 'Enquiry';
  export let endpoint: string = '/enquiries';

  // Fallbacks for safety
  const safeType = type ?? 'Enquiry';
  const safeEndpoint = endpoint ?? '/enquiries';
</script>

<Base {safeEndpoint}>
  {#if safeType === 'Enquiry'}
    <Enquiry />
  {:else if safeType === 'Referral'}
    <Referral />
  {:else if safeType === 'Newsletter'}
    <Newsletter />
  {/if}
</Base>
